import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { CommandSeparator } from 'cmdk';
import { forwardRef } from 'react';
import { separator } from '../../../shared/styles/separator.vanilla.mjs';

const SingleSelectSeparator = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(separator, classNameFromProps);
  return /* @__PURE__ */ jsx(
    CommandSeparator,
    {
      "data-scope": "single-select",
      "data-part": "separator",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectSeparator as SelectSeparator };
//# sourceMappingURL=Separator.mjs.map
